import { connect } from "react-redux";
import { withStyles } from "@mui/styles";
import React, { Component, useEffect, useState } from "react";
import ClaimEdit from "./ClaimEdit";
import ClaimList from "./ClaimList";
import { eClaimActions, userActions } from "../../../actions";
import { bindActionCreators } from "redux";
import Typography from "@mui/material/Typography";
import SimpleMessageDialog from "../../../components/SimpleMessageDialog";
import LoadingPopup from "../../../components/LoadingPopup";
import { getEclaimState } from "../../../selectors/CommonSelectors";
import { Box, Button, Card, CardContent } from "@mui/material";
import Enums from "../../../utils/Enums";
import { claimTypeData } from "./ClaimEdit/ClaimEditClaimTypeSection";
import SimpleClaimSubmitDialog from "../../../components/SimpleClaimSubmitDialog";
//import MobileNumberRequiredDialog from "./MobileNumberRequiredDialog"; -- PACSEB-13574 To ensure the functionality can be reinstated in future if required

class MyClaims extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedClaim: null,
      showClaimSubmitDialog: false
      //showMobileDialog: false -- PACSEB-13574 To ensure the functionality can be reinstated in future if required
    };
  }

  handleMakeClaim = () => {
    // PACSEB-13574 To ensure the functionality can be reinstated in future if required
    // const { loggedUser } = this.props;
    // const mobileNumberFetched = loggedUser && loggedUser.mobileNumberFetched;
    // const mobileNo = loggedUser && loggedUser.mobile_no;
    // if (mobileNumberFetched && !mobileNo) {
    //   this.setState({ showMobileDialog: true });
    //   return;
    // }
    this.setState({ selectedClaim: null }, () => {
      this.props.viewClaim();
    });
  };
  
  // PACSEB-13574 To ensure the functionality can be reinstated in future if required
  // handleMobileDialogClose = () => {
  //   this.setState({ showMobileDialog: false });
  // };

  handleViewClaim = idx => e => {
    this.props.getClaim(idx).then(
      response => {
        if (response.success) {
          this.setState({ selectedClaim: response.data }, () => {
            this.props.viewClaim();
          });
        }
      },
      errors => {
        this.props.showClaimErrorDialog();
      }
    );
  };

  fetchClaims = () => {
    this.props.clearClaimListError();
    this.props.fetchClaims();
  };

  handleCloseClaim = () => {
    this.props.closeClaim();
    this.fetchClaims();
    this.setState({ showClaimSubmitDialog: false });
    this?.props?.resetAddClaim();
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.showClaimDialog &&
      nextProps.showClaimDialog !== this.props.showClaimDialog
    ) {
      this.fetchClaims();
    }
  }

  getStatusText = status => {
    if (status === "SUBMITTED") {
      return (
        <Typography
          style={{
            color: "#4289e6"
          }}
        >
          Submitted
        </Typography>
      );
    } else if (status === "PROCESSING") {
      return (
        <Typography
          style={{
            color: "#4289e6"
          }}
        >
          Processing
        </Typography>
      );
    } else if (status === "ON_HOLD") {
      return (
        <Typography
          style={{
            color: "#4289e6"
          }}
        >
          On Hold
        </Typography>
      );
    } else if (status === "APPROVED") {
      return (
        <Typography
          style={{
            color: "#18c494"
          }}
        >
          Approved
        </Typography>
      );
    } else if (status === "REJECTED") {
      return (
        <Typography
          style={{
            color: "#e61928"
          }}
        >
          Rejected
        </Typography>
      );
    } else {
      return (
        <Typography
          style={{
            color: "#e61928"
          }}
        >
          Action Needed
        </Typography>
      );
    }
  };

  checkPlanType = () => {
    const data = this?.props?.addClaimSuccess;
    const loggedUser = this?.props?.loggedUser;
    if (
      data &&
      (data?.claim_type === Enums.CLAIM_TYPE.INPATIENT ||
        data?.claim_type === Enums.CLAIM_TYPE.OUTPATIENT_SP) &&
      (loggedUser?.policy?.product_code === "GCP" ||
        loggedUser?.policy?.product_code === "PCE")
    ) {
      const categories = loggedUser?.policy?.data?.categories || [];
      const claimType = claimTypeData?.find(
        item => item?.value === data?.claim_type
      );
      const gcpCodes = claimType?.code?.GCP || [];
      const pceCodes = claimType?.code?.PCE || [];

      const isMatchFound = categories?.some(category => {
        const plansConfiguration = category?.plansConfiguration || [];
        return plansConfiguration?.some(
          plan => gcpCodes.includes(plan?.code) || pceCodes.includes(plan?.code)
        );
      });

      if (isMatchFound) {
        return this.setState({ showClaimSubmitDialog: true });
      }
    }

    this.handleCloseClaim();
  };

  componentDidMount() {
    this.fetchClaims();
    this.checkPlanType();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.addClaimSuccess !== this?.props?.addClaimSuccess) {
      this.checkPlanType();
    }
  }

  render() {
    const {
      classes,
      showClaimDialog,
      showClaimError,
      isLoading,
      claimErrors,
      claimsListError
    } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <ClaimList
            getStatusText={this.getStatusText}
            handleMakeClaim={this.handleMakeClaim}
            handleViewClaim={this.handleViewClaim}
          />

          {claimsListError && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              marginTop="10rem"
            >
              <Card>
                <CardContent>
                  <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                  >
                    <Typography textAlign="center">
                      Unable To Retrieve Data
                    </Typography>
                    <Typography marginBottom="1rem" textAlign="center">
                      Please Try Again
                    </Typography>
                    <Button variant="contained" onClick={this.fetchClaims}>
                      Retry
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          )}

          {showClaimDialog && (
            <ClaimEdit
              getStatusText={this.getStatusText}
              handleCloseClaim={this.handleCloseClaim}
              open={showClaimDialog}
              selectedClaim={this.state.selectedClaim}
            />
          )}

          {showClaimError && (
            <SimpleMessageDialog
              open={showClaimError}
              closeHandler={this.props.closeClaimErrorDialog}
              title="Claim Processing Error"
              description={
                claimErrors !== ""
                  ? claimErrors
                  : "Error while processing the claims."
              }
              closeButtonText={"OK"}
            />
          )}
        </div>
        <LoadingPopup name="my-claim-loading" open={isLoading} />
        <SimpleClaimSubmitDialog
          title=""
          name=""
          closeButtonText="OK"
          showCloseIcon={true}
          url="https://www.prudential.com.sg/enterprise/employee-benefits/value-added-services/health-wellness"
          open={this.state.showClaimSubmitDialog}
          handleClose={() => {
            this.handleCloseClaim();
          }}
        />
        {/* PACSEB-13574 To ensure the functionality can be reinstated in future if required */}
        {/* <MobileNumberRequiredDialog
          open={this.state.showMobileDialog}
          onClose={this.handleMobileDialogClose}
          isEmulated={this.props.isEmulated}
        /> */}
      </div>
    );
  }
}
const styles = theme => ({
  root: {
    marginLeft: 30,
    marginRight: 30,
    marginTop: 30,
    marginBottom: 30,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 10,
      marginRight: 10
    }
  },
  content: {
    padding: theme.spacing.unit * 2.5
  },
  tabRoot: {
    minWidth: "auto",
    marginRight: theme.spacing.unit * 3
  },
  labelContainer: {
    paddingLeft: 0,
    paddingRight: 0,
    textTransform: "none"
  },
  indicator: {
    backgroundColor: theme.colors.primary.red,
    height: 3
  }
});

function mapStateToProps(state) {
  const {
    showClaimDialog,
    showClaimError,
    isLoading,
    claimErrors,
    claimsListError
  } = getEclaimState(state);

  const pcode = state?.user?.auth?.pcode;
  const isEmulated = [
    Enums.P_CODE.PRU_CE_EMULATE,
    Enums.P_CODE.PRU_AGENCY_EMULATE
  ].includes(pcode);

  return {
    showClaimDialog,
    showClaimError,
    isLoading,
    claimErrors,
    claimsListError,
    loggedUser: state?.user,
    addClaimSuccess: state?.eclaim?.addClaimSuccess?.claimants,
    isEmulated
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(eClaimActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MyClaims));